import { render, staticRenderFns } from "./UpdatePromotion.vue?vue&type=template&id=56202649&scoped=true"
import script from "./UpdatePromotion.vue?vue&type=script&lang=js"
export * from "./UpdatePromotion.vue?vue&type=script&lang=js"
import style0 from "./UpdatePromotion.vue?vue&type=style&index=0&id=56202649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56202649",
  null
  
)

export default component.exports